/**
* 左边菜单
*/
<template>
  <div>
    <el-menu
      :collapse="collapsed"
      :default-active="$route.path"
      collapse-transition
      router
      unique-opened
      class="el-menu-vertical-demo"
      active-text-color="#141464"
      text-color="#666666"
    >
      <div class="logobox" @click="jumedit()" style="cursor: pointer;"><img class="logoimg" src="../assets/img/logo.png" alt=""/></div>
      <el-menu-item
        :index="1"
        v-for="(menu, index) in allmenu"
        :key="index"
        v-if="!menu.child"
      >
        <template>
          <i class="element-icons" :class="menu.icon"></i>
          <span>{{ menu.title }}</span>
        </template>
      </el-menu-item>
      <el-submenu :index="menu.title+menu.id" v-else >
        <template slot="title">
          <i class="element-icons" :class="menu.icon" ></i>
          <span>{{ menu.title }}</span>
          <!-- <span>{{ menu.url }}</span> -->
          <!-- <el-link
            v-show="menu.title == '项目'"
            :underline="false"
            :disabled='disabled'
            icon="el-icon-tainjia"
            @click="jumedit()"
            style="margin-left: 100px"
          ></el-link> -->
        </template>
        <label v-for="(menu_child, index2) in menu.child" :key="index2">
          <el-menu-item :index="menu_child.url" v-if="!menu_child.child">
            <template>
              <span>{{ menu_child.title }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="menu_child.title" v-else>
            <template slot="title">
              <!-- <i class="element-icons" :class="menu.icon"></i> -->
              <span>{{ menu_child.title }}</span>
            </template>
            <el-menu-item-group
              v-for="(menu_child_child, index3) in menu_child.child"
              :key="index3"
            >
              <el-menu-item :index="menu_child_child.url">
                <span>{{ menu_child_child.title }}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </label>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
  import {getMenu} from "../api/userMG";

  export default {
    name: "leftnav",
    data() {
      return {
        collapsed: false,
        disabled: false,
        allmenu: [],
        // allmenu: [
        //   {
        //     title: "工作",
        //     icon: "el-icon-gongzuotai",
        //     child: [
        //       { title: "我的任务" , url:"/work/myTask"},
        //       { title: "全局视图" ,url:"/work/gloview"},
        //       { title: "时间视图" ,url: "/work/index" },
        //       { title: "人员视图",url:'/work/peoview' },
        //     ],
        //   },
        //   {
        //     title: "项目",
        //     icon: "el-icon-xiangmuxuqiu",
        //     child: [
        //       {
        //         title: "管理类系统开发",
        //         child: [{ title: "袋鼠搜索系统" }, { title: "股票查询系统" }],
        //       },
        //       { title: "如意养车",url: "/myproject/itemOne" },
        //     ],
        //   },
        //   {
        //     title: "系统设置",
        //     icon: "el-icon-shezhi",
        //     child: [
        //       { title: "项目设置", url: "/setting/setting" },
        //       { title: "团队管理", url: "/setting/gmanage" },
        //       { title: "部门管理", url: "/setting/dmanage" },
        //       { title: "权限组", url: "/setting/permission" },
        //     ],
        //   },
        //   {
        //     title: "账户安全",
        //     icon: "el-icon-ziyuan",
        //     child: [
        //       { title: "个人资料", url: "/account/role" },
        //       { title: "修改密码", url: "/account/user" },
        //     ],
        //   },
        // ],
      };
    },
    methods: {
      jumedit() {
        if (this.$route.path == '/work/myTask') {
          this.$message({
            message: '已在当前页面',
            type: 'warning'
          });
        } else {
          this.$router.push({path: "/work/myTask"});
        }
      },
      getMenuList() {
        let params = {
          token: localStorage.getItem("token"),
          is_menu: 1,
        };
        getMenu(params).then((res) => {
          if (res.errno === 0) {
            this.allmenu = res.data;
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
      getColl(){
        if(localStorage.getItem('collapse')=='true'){
          this.collapsed = true
        }else{
          this.collapsed = false
        }
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.$root.Bus.$on("toggle", (value) => {
        this.collapsed = value;
        console.log(value)
      });
      // this.$root.Bus.$on("toggle1", (value) => {
      //   this.collapsed = !value;
      //   console.log(value)
      //   this.getMenuList()
      // });


    },

    mounted() {
      this.getColl()
      this.getMenuList();
    },
  };
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #fbfbfb !important;
  }


  .el-menu {
    border: none;
  }


  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 10px 0px;
    overflow: hidden;
    /* background-color: red; */
  }
  .aside .logobox{
    padding-left: 7px;
  }

  .el-menu-item.is-active {
    /* color: red; */
    background: #fbfbfb !important;
    font-weight: 600;
    /* font-size: 15px; */
    border-right: 2px solid #2b52e9;
  }

  .el-menu-item,
  .el-submenu__title,
  .el-submenu .el-menu-item {
    height: 60px;
    line-height: 60px;
  }

  .el-menu-item {
    display: flex;
    align-items: center;
  }

  .navigation span {
    cursor: pointer;
  }

  .el-menu-item span{
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .el-menu-item:hover {
    background: #fbfbfb !important;
    color: #808080 !important;
  }

  .el-menu-item:hover i {
    color: #808080 !important;
  }

  .el-submenu__title:hover {
    background: #fbfbfb !important;
    /* color: #2b52e9 !important; */
  }

  .el-submenu__title:hover i {
    color: #2b51e8 !important;
  }


  .el-submenu__title:hover span {
    color: #2b51e8 !important;
  }

  .element-icons {
    margin-right: 5px;
  }

  .el-menu-item i {
    color: #808080
  }

  .el-submenu__title i {
    color: #808080;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue